module.exports = __webpack_public_path__ + "img/flare.e03fb691.png";